import PropertyActivity from './PropertyActivity';

export default PropertyActivity;
